<template>
<el-card>
  <template v-slot:header>
    <div>
      <span class="mr-[40px]">角色管理</span>
      <el-button type="primary" @click="add()">添加角色</el-button>
      <el-button  @click="refresh()">刷新</el-button>
    </div>
  </template>

  <el-table ref="multipleTable" :data="roles" border>
    <el-table-column fixed prop="index" label="序号" width="70">
      <template v-slot="{row}">
        <div class="whitespace-nowrap overflow-hidden overflow-ellipsis">{{ row.index }}</div>
      </template>
    </el-table-column>
    <el-table-column prop="name" label="名称" width="100">
      <template v-slot="{row}">
        <div class="whitespace-nowrap overflow-hidden overflow-ellipsis">{{ row.name }}</div>
      </template>
    </el-table-column>
    <el-table-column prop="permissions" label="拥有权限">
      <template v-slot="{row}">
        <div class="whitespace-nowrap overflow-hidden overflow-ellipsis">{{ row.permissions }} 签署证书、用户管理、角色管理、权限管理</div>
      </template>
    </el-table-column>
    <el-table-column fixed="right" label="操作" width="160">
      <template v-slot="scope">

        <el-button @click="edit(scope.row)" type="primary" size="mini">编辑</el-button>
        <el-button @click="remove(scope.row)" type="danger" size="mini">删除</el-button>
      </template>
    </el-table-column>
  </el-table>

  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="300px">
    <el-form :model="editItem" label-width="80px">
      <el-form-item label="名称">
        <el-input v-model="editItem.name" maxlength="32"></el-input>
      </el-form-item>
      <el-form-item label="权重">
        <el-input v-model.number="editItem.weight" validate-number maxlength="6"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save()">保 存</el-button>
    </span>
  </el-dialog>
</el-card>
</template>

<script>
import { 
  fetchRoles,
  deleteRole,
  addRole,
  updateRole,
} 
from '@/api/api';
export default {
  name:"RolePage",
  data() {
    return {
      roles: [],
      multipleSelection:[],
      editItem: {
        id: 0, 
        name: "",
        weight: 0,
        action: "",
      },
      dialogTitle: "",
      dialogVisible: false,
      orgId: 1,
    }
  },

  mounted() { 
    this.getRoles();
  },

  methods: {
    getRoles() {
      let that = this;
      fetchRoles(this.orgId).then(result => {
        try{
          that.roles=[];
          let data = result.data.data;
          let count = data.total;
          for (let i=0; i<count; i++) {
            let item = {}
            item.index = i+1;
            item.id = data.roles[i].id;
            item.name = data.roles[i].name;
            item.weight = data.roles[i].weight;
            item.permissions = data.roles[i].permissions;
            item.orgId = data.roles[i].org_id;
            that.roles.push(item);
          }
        }catch(err) {
          this.$message.error(err);
        }
      })
      .catch(err => {
        this.$message.error(err);
      });
    },

    refresh(){
      this.getRoles();
    },

    add() {
      event.stopPropagation();
      this.editItem.id = 0; 
      this.editItem.name = "";
      this.editItem.weight = 0;
      this.editItem.action ="add";
      this.dialogTitle = '添加角色';
      this.dialogVisible = true;
    },

    edit(role) {
      event.stopPropagation();
      this.editItem.id = role.id; 
      this.editItem.name = role.name;
      this.editItem.weight = role.weight;
      this.editItem.action ="edit";
      this.dialogTitle = '编辑角色';
      this.dialogVisible = true;
    },

    remove(role) {
      event.stopPropagation();
      this.$confirm("您确定要删除【" + role.name + "】吗？", '删除角色', {
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          type: 'warning'
        }).then(() => {
          deleteRole(this.orgId, role.id).then(() =>{
            this.$message({message: '删除成功',type: 'success'});
            this.getRoles();
          })
        }).catch((err) => {
          if (err == "cancel") {  
            return
          }
          this.$message.error(err);
        })
    },

   save() {
      this.editItem.name = this.editItem.name.trim()
      if (this.editItem.name.length == 0) {
        this.$message.error("名称不能为空");
        return;
      }
      const data = JSON.stringify({
        "id": this.editItem.id,
        "name": this.editItem.name,
        "weight": this.editItem.weight,
        "permissions": this.editItem.permissions,
        "org_id" : this.orgId
      });
      if( this.editItem.action == "add") {
        addRole(data).then(() =>{
          this.dialogVisible = false;
          this.$message({message: '添加成功',type: 'success'});
          this.getRoles();
        }).catch((err)=> {
          this.$message.error(err);
        });
      } else {
        updateRole(data).then(() =>{
          this.dialogVisible = false;
          this.$message({message: '更新成功',type: 'success'});
          this.getRoles();
        }).catch((err)=> {
          this.$message.error(err);
        });
      }
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },

    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    }
  },
}
</script>